import { observer } from "mobx-react";
import {
    AUTO_PROCESS_EXECUTE,
    SINCE_UNIT,
    autoProcessExecuteOptionsList,
    autoProcessTriggerOptionsList,
    autoProcessValidatedQualifierOptionsList,
    sinceUnitOptionsList,
     getAutoProcessSinceValueOptions
} from "../../../../../../constants";
import { FormFieldLine } from "../../../../../../../../components/form-field-line/form-field-line";
import { SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import PolicyStore from "../../../../../../stores/policy-store";
import '../process-trigger-settings.scss';
import { AUTO_PROCESS_TRIGGER, AUTO_PROCESS_VALIDATED_QUALIFIER } from "../../../../../../../../models/User";
import { IValidationGroup } from "../../../../../../../../hooks/validation-group/validation-group-hook";

interface IProps {
    policy: PolicyStore,
    validationGroup: IValidationGroup,
}

const RefundTriggerSettings: React.FC<IProps> = observer(({policy, validationGroup }) => {
    const selectedAutoProcessTrigger = autoProcessTriggerOptionsList().find(o => o.value === policy.autoRefundTrigger);
    const selectedAutoProcessValidatedQualifier = autoProcessValidatedQualifierOptionsList().find(o => o.value === policy.autoRefundValidatedQualifier);
    const selectedAutoProcessExecute = autoProcessExecuteOptionsList().find(o => o.value === policy.autoRefundExecute);
    const selectedAutoProcessSinceUnit = sinceUnitOptionsList().find(o => o.value === policy.autoRefundSinceUnit);
    
    const autoProcessSinceValueOptions = getAutoProcessSinceValueOptions(policy.autoRefundSinceUnit);
    const selectedAutoProcessSinceValue = autoProcessSinceValueOptions.find(o => o.value === policy.autoRefundSinceValue);
    const showExecuteSince = policy.autoRefundExecute && policy.autoRefundExecute !== AUTO_PROCESS_EXECUTE.IMMEDIATELY;

    return (
        <>
            <FormFieldLine required label='Trigger' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                <SelectDropdown
                    value={selectedAutoProcessTrigger}
                    options={autoProcessTriggerOptionsList()}
                    onChange={(v) => policy.setAutoRefundTrigger(v?.value as AUTO_PROCESS_TRIGGER)}
                    required
                    validationGroup={validationGroup}
                    isSearchable={false}
                />
            </FormFieldLine>

            {policy.autoRefundTrigger === AUTO_PROCESS_TRIGGER.ITEMS_VALIDATED &&
                <FormFieldLine required label='Validation' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                    <SelectDropdown
                        value={selectedAutoProcessValidatedQualifier}
                        options={autoProcessValidatedQualifierOptionsList()}
                        onChange={(v) => policy.setAutoRefundValidatedQualifier(v?.value as AUTO_PROCESS_VALIDATED_QUALIFIER)}
                        required
                        validationGroup={validationGroup}
                        isSearchable={false}
                    />
                </FormFieldLine>
            }

            <FormFieldLine required label='Execute' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                <SelectDropdown
                    value={selectedAutoProcessExecute}
                    options={autoProcessExecuteOptionsList()}
                    onChange={(v) => policy.setAutoRefundExecute(v?.value as AUTO_PROCESS_EXECUTE)}
                    required
                    validationGroup={validationGroup}
                    isSearchable={false}
                />
            </FormFieldLine>

            {showExecuteSince &&
                <FormFieldLine label='' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                    <div className="execute-since-fields">
                        <SelectDropdown
                            value={selectedAutoProcessSinceValue}
                            options={autoProcessSinceValueOptions}
                            onChange={(v) => policy.setAutoRefundSinceValue(v?.value as number)}
                            validationGroup={validationGroup}
                            required
                            isSearchable={false}
                        />

                        <SelectDropdown
                            value={selectedAutoProcessSinceUnit}
                            options={sinceUnitOptionsList()}
                            onChange={(v) => policy.setAutoRefundSinceUnit(v?.value as SINCE_UNIT)}
                            validationGroup={validationGroup}
                            required
                            isSearchable={false}
                        />
                    </div>
                </FormFieldLine>
            }
        </>
    )
});

export default RefundTriggerSettings;